import React from "react";
import { Container, Row, Col, Form } from "react-bootstrap"; 
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap"; 
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      {/* Top Section */}
      <section className="footer-top">
        <Container>
          {/* <h3>Get In Touch</h3>
          <p>
            Subscribe to Shaadi Baraati and Get access to our latest Blogs,
            Wedding Ideas and get the best quotes from trusted Wedding Vendors.
          </p> */}

          {/* Email Subscribe */}
         {/* <Form className="email-form">
  <Form.Control
    type="email"
    placeholder="Email"
    className="email-input"
  />
  <button type="submit" className="email-btn">
    Get Start
  </button>
</Form> */}


          {/* Contact Info */}
          <Row className="text-center contact-row">
            <Col md={6} className="contact-col">
              <FaEnvelope size={28} className="contact-icon" />
              <h6>Mail</h6>
              <p> biontechnologysolutionbts@gmail.com</p>
            </Col>
            <Col md={6} className="contact-col">
              <FaPhoneAlt size={28} className="contact-icon" />
              <h6>Support</h6>
              <p>+91 8883513557</p>
            </Col>
          </Row>

          {/* Custom Action Buttons */}
          {/* <Row className="button-row text-center">
            <Col><button className="action-btn">Pay UPI</button></Col>
            <Col><button className="action-btn">Pay Now</button></Col>
            <Col><button className="action-btn">Login Now</button></Col>
            <Col><button className="action-btn">Register as Vendor</button></Col>
          </Row> */}
        </Container>
      </section>

      {/* Footer Links & Info */}
      <Container>
        <Row className="footer-top">
          <Col md={4} sm={12} className="footer-brand">
            <h3>Vaibhavam</h3>
            <p>
              Helping you plan events effortlessly with top venues, vendors, and tools.
              Your celebration, our priority.
            </p>
          </Col>

          <Col md={4} sm={6} className="footer-links">
            <h5>Quick Links</h5>
            <ul>
              <li><Nav.Link as={Link} to="/home" className="nav-link">Home</Nav.Link></li>
              <li><Nav.Link as={Link} to="/venue" className="nav-link">Venues</Nav.Link></li>
              <li><Nav.Link as={Link} to="/vendor" className="nav-link">Vendors</Nav.Link></li>
              <li><Nav.Link as={Link} to="/about" className="nav-link">About us</Nav.Link></li>  
            </ul>
          </Col>

          <Col md={4} sm={6} className="footer-social">
            <h5>Follow Us</h5>
            <div className="social-icons">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaInstagram /></a>
            </div>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col className="text-center">
            <p>© {new Date().getFullYear()} Vaibhav. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
